import { Badge } from '@round/whitelabel-ui';
import cn from 'classnames';
import styles from './AllocationBadge.module.css';
import capitalize from 'lodash/capitalize';

type AllocationState = 'unallocated' | 'partially-allocated' | 'fully-allocated';

type Props = {
    originalAmount: number;
    allocatedAmount: number;
};

const AllocationBadge = ({ originalAmount, allocatedAmount }: Props) => {
    const allocationStatus: AllocationState =
        allocatedAmount === 0
            ? 'unallocated'
            : allocatedAmount === originalAmount
              ? 'fully-allocated'
              : 'partially-allocated';

    return (
        <div className={styles.wrapper}>
            <Badge className={cn(styles.allocationBadge, styles[allocationStatus])}>
                {allocationStatus.split('-').map(capitalize).join(' ')}
            </Badge>
        </div>
    );
};

export default AllocationBadge;
